import { TFunction } from 'react-i18next';
import { DEVELOPER_FORM_FIELDS, DEVELOPER_FORM_FIELDS_NAMES } from './developer-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

interface Props {
  t: TFunction;
}

export const MERCHANT_DEVELOPER_INPUTS = ({ t }: Props): IFormInputProps[] => [
  {
    key: DEVELOPER_FORM_FIELDS.FIRST_NAME,
    fieldName: DEVELOPER_FORM_FIELDS.FIRST_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(DEVELOPER_FORM_FIELDS_NAMES.FIRST_NAME)}`,
    label: t(DEVELOPER_FORM_FIELDS_NAMES.FIRST_NAME),
    inputType: InputType.Text,
  },
  {
    key: DEVELOPER_FORM_FIELDS.LAST_NAME,
    fieldName: DEVELOPER_FORM_FIELDS.LAST_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(DEVELOPER_FORM_FIELDS_NAMES.LAST_NAME)}`,
    label: t(DEVELOPER_FORM_FIELDS_NAMES.LAST_NAME),
    inputType: InputType.Text
  },
  {
    key: DEVELOPER_FORM_FIELDS.EMAIL,
    fieldName: DEVELOPER_FORM_FIELDS.EMAIL,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(DEVELOPER_FORM_FIELDS_NAMES.EMAIL)}`,
    label: t(DEVELOPER_FORM_FIELDS_NAMES.EMAIL),
    inputType: InputType.Text,
  },
  {
    key: DEVELOPER_FORM_FIELDS.PHONE,
    fieldName: DEVELOPER_FORM_FIELDS.PHONE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(DEVELOPER_FORM_FIELDS_NAMES.PHONE)}`,
    label: t(DEVELOPER_FORM_FIELDS_NAMES.PHONE),
    inputType: InputType.Phone,
    defaultCountry: 'US',
    additionalClasses: 'number-input-zip',
  },
];
